// src/utils/objectToFormData.ts

const isFileLike = (v: any) =>
  v instanceof File ||
  (typeof v === "object" &&
    v !== null &&
    (v instanceof Blob ||
      (typeof v.size === "number" &&
        typeof v.type === "string" &&
        typeof v.name === "string")));

const normalizeToFile = (val: any): File | undefined => {
  if (!val) return undefined;

  if (val instanceof FileList && val.length > 0) return val[0];

  if (isFileLike(val)) return val as File;

  if (Array.isArray(val) && val.length > 0) {
    const first = val[0];
    if (isFileLike(first)) return first;
    if (first?.originFileObj && isFileLike(first.originFileObj))
      return first.originFileObj;
    if (first?.file && isFileLike(first.file)) return first.file;
  }

  if (val?.originFileObj && isFileLike(val.originFileObj))
    return val.originFileObj;

  if (val?.file && isFileLike(val.file)) return val.file;

  return undefined;
};

export const objectToFormData = (obj: any) => {
  if (obj instanceof FormData) return obj;

  const fd = new FormData();

  Object.entries(obj || {}).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    const file = normalizeToFile(value);
    if (file) {
      fd.append(key, file);
      return;
    }

    if (Array.isArray(value)) {
      fd.append(key, JSON.stringify(value));
      return;
    }

    if (typeof value === "object") {
      fd.append(key, JSON.stringify(value));
      return;
    }

    fd.append(key, String(value));
  });

  return fd;
};
